<template>
  <gj-modal
      :visible.sync="modalVisible"
      :loading="importHandleLoading"
      :loading-text="importHandleLoadingText"
      size="normal"
  >
    <template #header>导入结果</template>
    <template #content>
      <gj-upload
          :template-url="`/supply/storageCheck/downloadCheckResultTemplate?id=${id}`"
          @uploadAfter="uploadAfter"
          container-type="inventoryImportResult"
          style="margin-bottom: 12px"
      >
        <template #tip>
          <span>只能上传xls/xlsx文件</span>
        </template>
      </gj-upload>
      <gj-import-alert
          :rules="[
            '模板中的表头不可更改，不能删除',
          ]">
      </gj-import-alert>
    </template>
  </gj-modal>
</template>

<script>
  import {modalMixIn, responseMixin, uploadMixin} from "../../../../../minxins";
  import {importStorageCheckResult} from "../../../../../api/warehouse";

  export default {
    name: "import-result",
    mixins: [modalMixIn, uploadMixin, responseMixin],
    props: {
      id: null,
    },
    methods: {
      uploadAfter(attId, data, uploadCb) {
        this.importHandleLoading = true;
        importStorageCheckResult({attachmentId: attId, id: this.id})
          .then((res) => {
            this.$gjImportHandle(res, uploadCb)
          }).catch(() => {
            uploadCb('error')
          }).complete(() => {
          this.$gjDestroy();
          this.importHandleLoading = false;
        });
      }
    }
  }
</script>

<style scoped>

</style>
